module.exports = __webpack_public_path__ + "static/img/bg3.6d881cfd.png";